import { signal } from "@preact/signals";

export const embedToken = signal<string | null>(null);
